module.exports = __webpack_public_path__ + "img/PVSA.a11733da.png";